const fetcher = (url) => fetch(
  `${process.env.REACT_APP_NEXT_PUBLIC_SERVER_ENDPOINT}${url}`,
  { credentials: 'include' }
).then(r => r.json());

export default fetcher;